// Convert to yyy-mm-dd
export const formatDate = (dateInput) => {
  const date = new Date(dateInput);
  console.log("date", date);
  
  // Extract year, month, and day from the date
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");

  // Combine into desired format
  return `${year}-${month}-${day}`;
};

// Convert back to origibnal formta
export const parseFormattedDate = (formattedDate) => {
  const [year, month, day] = formattedDate.split("-");

  // Create a new Date object using the parsed year, month, and day
  // Note: Month is 0-indexed in the Date constructor, so subtract 1 from the month
  return new Date(year, month - 1, day);
};

// convert this "2024-08-14" to format like "14, August 2024"
export const formatScheduleListDate = (dateString) => {
  // Array of month names
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Create a Date object from the input string
  const date = new Date(dateString);

  // Get the day, month, and year
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  // Return the formatted date
  return `${day} ${month} ${year}`;
};

// Format "12 Sep 24"
export const formatShortScheduleListDate = (dateString) => {
  // Array of abbreviated month names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Create a Date object from the input string
  const date = new Date(dateString);

  // Get the day, month, and year
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2); // Get last 2 digits of the year

  // Return the formatted date
  return `${day} ${month} ${year}`;
};

// Format "02/10/2024"
export function formatTransactionDate(dateString) {
  // Create a new Date object from the provided date string
  const date = new Date(dateString);

  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  // Return the date in "DD/MM/YYYY" format
  return `${day}/${month}/${year}`;
}
